import { useMutation } from '@tanstack/react-query';

import { postSubscribeToNewPropertyNotifications } from '@arrived/api_v2';
import { SubscriptionResponse, UserEmail } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';

export interface EmailSubscribeMutationRequest {
  email: UserEmail;
}

export function useEmailSubscribeMutation(
  options?: UseMutationOptions<SubscriptionResponse, EmailSubscribeMutationRequest>
) {
  return useMutation(({ email }) => postSubscribeToNewPropertyNotifications(email), options);
}
